import { Company } from 'generated/apolloComponents'
import CompanyHeaderInfo from '@/components/molecules/CompanyHeaderInfo'
import NavTabs from '@/components/molecules/NavTabs'
import styles from '../Company.module.scss'

type ListItem = {
  title: string
  url: string
  slug: string
}

type Props = {
  company: Company
  menu: ListItem[] | {}[]
  navRefs: any
}

const BrandLayout = ({ company, menu, navRefs }: Props) => {
  const color = company?.themeColor || '#726EFF'
  return (
    <>
      <div
        className={`${styles['company__cover--basic']} relative bg-gray-bg container`}
      >
        <CompanyHeaderInfo
          company={company}
          layout={company.currentLayout || 'light'}
          className='rounded-t-xl'
          headerTheme='dark'
        />
      </div>

      <div
        className={`lg:sticky mx-auto lg:container z-70 relative ${styles.company__nav__container}`}
      >
        <div className={`${styles.company__nav} bg-white  lg:rounded-b-xl `}>
          <NavTabs
            className='flex'
            color={color}
            data={menu}
            navRefs={navRefs}
          />
        </div>
      </div>
    </>
  )
}

export default BrandLayout
